import React from 'react';
import './button.css'
import {trackClick} from "../../utils/Analytics";

export function ButtonComponent({onClick, analyticsName, className, ariaLabel, icon, text, color}) {
    return (<button aria-label={ariaLabel} className={"button " + color + (text ? " withText" : "") + " " + className}
                    onClick={() => {
                        trackClick("ButtonComponent", analyticsName)
                        onClick()
                    }}>
        {icon && <span className={"buttonIcon" + (text ? " withText" : "")}>{icon}</span>}
        {text && <span className="buttonText">{text}</span>}
    </button>);
}
